import React from 'react'
import TagManager from 'react-gtm-module'
import {getTagManagerArgs} from './Util';
import GeneLinkBanner from './GeneLinkBanner'
import { GENELINK_BANNERS } from '../constants/GeneLinkBanners'
import { buildAdscreenUrl } from '../services/geneLinkService'
import { Link } from 'react-router-dom'

export default class Top extends React.Component{

  handleClickOpen(unit_id){
    const { handleModalOpen } = this.props
    handleModalOpen(unit_id)
  }

  constructor(props) {
    super(props);
  }

  handleClickSwitchPage(page){
    if(this.props.toggleResult){
      this.props.toggleResultMethod()
    }
    this.props.switchPageMethod(page)
  }

  componentDidMount() {
    this.props.togglePageTop();
    TagManager.initialize(getTagManagerArgs('/top'));
  }

  render(){
    //const {show, title, children} = this.props
    // TODO エラーになっていたので一旦コメントアウト、再度使うなら原因追及
    const {setPage, nickname, lsc_status, lsc_result, affiliate_agreed} = this.props
    let toDietResult = null
    if (affiliate_agreed === true) {
      toDietResult =
          <div className="box_infoarea">
        <div className="text-center">
          <h2 className="title_primary">同じものを食べても遺伝的体質によって消化が違う？</h2>
        </div>
        <div className="box_infoarea_content">
          <div className="row">
            <div className="col imgcont">
              <img src="image/nutrition/top_img.jpg" alt="nutrition" />
            </div>
            <div className="col text_description textcont">
              <h3>DIETの結果を見てみよう！</h3>
              <p className="abovelink_text">実は、遺伝的な体質の違いによって、脂質や糖質のしかたが異なります。DIETの検査結果をチェックし、自分に合った最適な食生活を送りましょう。</p>
            </div>
          </div>
        </div>

        <div className="btn_wrap_fix belowtext">
          <Link to={{
            pathname: "/detail",
            state: { referer: "/" }
          }}
                className="btn_pry" onClick={this.props.openDietResult}>詳しく見る</Link>
        </div>
      </div>

    }
    const qvcBigDiscovery = this.props.special_kit_codes.indexOf('big_discovery') >= 0 ? (<div className="extra_view">
      <span>
      <Link to={{
        pathname: "/add10",
        state: {referer: "/"}
      }} onClick={this.handleClickSwitchPage.bind(this, "BigDiscovery")}
      >
        <h3>特別追加10項目</h3>
        <p>特別追加10項目一覧で検査結果を表示します。</p>
      </Link>
      </span>
        </div>
    ) : null;

    const specialCovid19ReportLink = this.props.special_kit_codes.indexOf('genesis2_early') == -1 ? (<li><Link to={{
      pathname: "/covid19",
      state: { referer: "/" }
    }} onClick={this.handleClickSwitchPage.bind(this, "Covid19")}>COVID-19のレポート</Link>
    </li>) : (
      <li><Link  to={{
          pathname: "/buyapp",
          state: { referer: "/" }
        }}>COVID-19のレポート</Link>
      </li>
    );
    return(
    <div className="wrap">
      <p className="top_gelogo"><img src="image/logo_genesis.svg" alt=""/></p>

      <ul className="top_menu">
        <li>
          <span className="top_l" onClick={(e)=>setPage('Disease')}>
          <Link to={{
            pathname: "/disease",
            state: { referer: "/" }
          }}>
            <p><img src="image/topmenu01.png" alt=""/></p>
            <p>疾患カテゴリ一覧で検査結果を表示します。</p>
          </Link>
          </span>
        </li>
        <li>
          <span className="top_c" href="#" onClick={(e)=>setPage('Constitution')}>
          <Link to={{
            pathname: "/constitution",
            state: { referer: "/" }
          }}>
            <p><img src="image/topmenu02.png" alt=""/></p>
            <p>体質カテゴリ一覧で検査結果を表示します。</p>
          </Link>
          </span>
        </li>
        <li>
          <span className="top_r" href="#" onClick={(e)=>setPage('Risklevel')}>
          <Link to={{
            pathname: "/risklevel",
            state: { referer: "/" }
          }}>
            <p><img src="image/topmenu03.png" alt=""/></p>
            <p>リスクレベル別に検査結果を表示します。</p>
          </Link>
          </span>
        </li>
      </ul>
      {qvcBigDiscovery}

      <div className="specific_view">
        <div className="specific_view_contents">
          <h3>コンテンツから見る</h3>
          <ul>
          <li>
              <Link to={{
              pathname: "/sevens",
              state: { referer: "/" }
            }} onClick={this.handleClickSwitchPage.bind(this, "Sevens")}>七大生活習慣病のリスク評価
              </Link>
            </li>
            <li>
              <Link to={{
              pathname: "/cancer",
              state: { referer: "/" }
            }} onClick={this.handleClickSwitchPage.bind(this, "Cancer")}>がんのリスク評価
              </Link>
            </li>

            {this.props.special_kit_codes.indexOf('genesis2_early') == -1 ? (<li><Link to={{
              pathname: "/covid19",
              state: { referer: "/" }
            }} onClick={this.handleClickSwitchPage.bind(this, "Covid19")}>新型コロナウィルス感染症(COVID-19)のリスク評価</Link>
            </li>) :""}
            <li>
            <Link to={{
            pathname: "/detail",
            state: { referer: "/" }
          }}
             onClick={this.props.openDietResult}>肥満タイプ(DIETの報告書)
              </Link>
            </li>
            <li>
            <Link  to={{
                pathname: "/detail",
                state: { referer: "/" }
              }} onClick={this.handleClickOpen.bind(this, 521)}>肌タイプ(SKINの報告書)
              </Link>
            </li>
            <li>
            <Link  to={{
                pathname: "/detail",
                state: { referer: "/" }
              }} onClick={this.handleClickOpen.bind(this, 550)}>筋肉の発達(SPORTSの報告書)
              </Link>
            </li>
            <li>
            <Link to={{
                pathname: "/detail",
                state: { referer: "/" }
              }} onClick={this.handleClickOpen.bind(this, 949)}>祖先のルーツ(ミトコンドリアハプログループ)
              </Link>
            </li>



            {(lsc_status == "ok") ?
              (lsc_result.length > 0) ?
                <li>
                  <Link to={{
                    pathname: "/lsc_content",
                    state: { referer: "/" }
                  }} onClick={this.handleClickSwitchPage.bind(this, "LscContent")}>ライフスタイル<br/>通信簿</Link></li>
              :
                ""
            :
             ""
            }
          </ul>
        </div>
        <div className="specific_view_popular">
          <h3>人気の検査項目を見る</h3>
            <ul>
              <li><Link to={{
                pathname: "/detail",
                state: { referer: "/" }
              }} onClick={this.handleClickOpen.bind(this, 949)}>ミトコンドリアハプログループ</Link></li>
              <li><Link  to={{
                pathname: "/detail",
                state: { referer: "/" }
              }} onClick={this.handleClickOpen.bind(this, 521)}>肌タイプ</Link></li>
              <li><Link  to={{
                pathname: "/detail",
                state: { referer: "/" }
              }} onClick={this.handleClickOpen.bind(this, 79)}>大腸がん</Link></li>
              {specialCovid19ReportLink}
            </ul>
        </div>
      </div>

      {toDietResult}
      <div className="genelink_bn">
        <ul>
          {GENELINK_BANNERS.map(banner => (
            <li key={banner.id}>
              <GeneLinkBanner
                creative_id={banner.creative_id}
                image={banner.image}
                adscreenUrl={buildAdscreenUrl({ creative_id: banner.creative_id, code: this.props.kit, customer_id: this.props.customer_id })}
                kit={this.props.kit}
                customer_id={this.props.customer_id}
              />
            </li>
          ))}
        </ul>
      </div>
      <div className="top_info">
        <h3>Information</h3>
        <ul>
          <li>（2018.10.2）筋肉タイプの検査結果報告書が<Link to={{
            pathname: "/detail",
            state: { referer: "/" }
          }} onClick={this.handleClickOpen.bind(this, 550)}>筋肉の発達</Link>の詳細ページから閲覧できるようになりました。（※該当項目が閲覧可能な方に限ります)</li>
          <li>（2018.9.21） 肥満タイプ・肌タイプの検査結果報告書が詳細ページから閲覧できるようになりました。（※該当項目が閲覧可能な方に限ります)</li>
          {(lsc_status == "ok") ?
              (lsc_result.length > 0) ?
          <li>（2018.7.30） ライフスタイル通信簿コンテンツをリリース致しました。</li>
         　　　:
              　""
          :
          　""
          }
          <li>（2017.11.2） ミトコンドリアハプログループをサブグループまで判定できるようにしました。</li>
          <li><a href="https://www.genelife.jp/page/personal" target="_blank" rel="noopener noreferrer">遺伝子検査結果に関する注意事項</a></li>
        </ul>
        <p className="cap-text">この検査はジェネシスヘルスケア株式会社によって開発され、その性能特性は当社によって確認しております。</p>
      </div>




    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Top.js